import url from 'url'
import {appendQuery} from '@/utils'
const env = process.env.VUE_APP_WEB
let query = url.parse(window.location.href, true).query
const sensors = window['sensorsDataAnalytic201505']

const defaultSaConfig = {
  local: {
    serverUrl: 'https://test-sensors-api.baidao.com/sa',
    token: '123wieu',
    project: 'rjhy_huntianling_test',
    projectId: 'other'
  },
  production: {
    serverUrl: 'https://jc-sensors.baidao.com/sa',
    token: 'Tktt6acg',
    project: 'rjhy_wechatall',
    projectId: 'wechat.all'
  }
}[env]

let saConfig = {
  local: {
    'wechat-common-htz': {
      serverUrl: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      projectId: 'wechat.htz'
    },
    'wechat-common-jfql': {
      serverUrl: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      projectId: 'wechat.jfql'
    }
  },
  development: {
    'wechat-common-htz': {
      serverUrl: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      projectId: 'wechat.htz'
    },
    'wechat-common-jfql': {
      serverUrl: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      projectId: 'wechat.jfql'
    }
  },
  uat: {
    'wechat-common-htz': {
      serverUrl: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      projectId: 'wechat.htz'
    },
    'wechat-common-jfql': {
      serverUrl: 'https://test-sensors-api.baidao.com/sa',
      token: '123wieu',
      project: 'rjhy_huntianling_test',
      projectId: 'wechat.jfql'
    }
  },
  production: {
    'wechat-common-htz': {
      serverUrl: 'https://jc-sensors.baidao.com/sa',
      token: '1zRWFX',
      project: 'rjhy_huitouzi',
      projectId: 'wechat.htz'
    },
    'wechat-common-jfql': {
      serverUrl: 'https://jc-sensors.baidao.com/sa',
      token: 'iueew98',
      project: 'rjhy_huntianling',
      projectId: 'wechat.jfql'
    }
  }
}[env][query.key] || defaultSaConfig


const isWeixin = () => {
  let ua = navigator.userAgent.toLowerCase()
  if(ua.match(/MicroMessenger/i) == "micromessenger") {
    return true
  } else {
    return false
  }
}

const getWechatVersion = () => {
  let version = ""
  if (isWeixin()) {
    var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d|.]+)/i)
    if(wechatInfo && wechatInfo.length > 1){
      // 获取微信的版本号
      version = wechatInfo && wechatInfo[1]
    }
  }
  return version
}

function brushWind (str) {
  if (!str) return ''
  return str.replace(/\d{11}/g, '****')
}

const getUserProfile = (userInfo) => {
  return {
    country: userInfo.country || '',
    province: userInfo.province || '',
    city: userInfo.city || '',
    nickname: brushWind(userInfo.nickname || ''),
    user_name: userInfo.userId || '',
    jfNumber: userInfo.jfNumber || '',
    open_id: userInfo.openid || '',
    unionid: userInfo.unionid || '',
    wechat_follow: !!userInfo.subscribe,
    phone_bind: !!userInfo.md5Phone
  }
}

const getCommonEventProperties = (userInfo, saConfig, serviceConfig) => {
  return {
    is_log_in: !!userInfo,
    user_name: userInfo.userId || '',
    jiufang_code: userInfo.jfNumber || '',
    nick_name: brushWind(userInfo.nickname || ''),
    head_img_url: userInfo.headImgUrl || '',
    project_id: saConfig.projectId,
    front_type: 'h5',
    platform_id: saConfig.projectId,
    app_id: serviceConfig.appId,
    wechat_follow: !!userInfo.subscribe,
    within_wechat: isWeixin(),
    wechat_version: getWechatVersion(),
    open_id: userInfo.openid || '',
    union_id: userInfo.unionid || '',
    phone_bind: !!userInfo.md5Phone,
    user_agent: navigator.userAgent,
    adviser_id: query.brokerCode || '', // 员工工号
    adviser_name: query.brokerName || '',
    pre_union_id: query.shareFromUnionId || '', // 来源人员
    pre_user_name: query.shareFrom || '',
    share_source: query.share_source || '',
    page_source: query.page_source || '',
    team_source: 'wechat-article-common'
  }
}
class Sa {
  constructor () {
    this.userId = ''
    this.platform = ''
    this.cbs = []
  }
  init (userId, userInfo, serviceConfig) {
    if (!saConfig) return
    let {serverUrl, token, project} = saConfig
    this.userId = userId
    sensors.init({
      server_url: appendQuery(serverUrl, { token, project }),
      heatmap_url: 'https://static.sensorsdata.cn/sdk/1.21.3/heatmap.min.js',
      web_url: '神策分析后台地址',
      heatmap: {
        clickmap: 'default',
        scroll_notice_map: 'not_collect'
      },
      show_log: true
    })
    // 设置公共用户属性
    sensors.setProfile(getUserProfile(userInfo));
    // 设置公共事情属性
    let commonPropertys = getCommonEventProperties(userInfo, saConfig, serviceConfig)
    sensors.registerPage(commonPropertys);
    sensors.login(userId)

    // 全埋点事件公共属性
    sensors.quick('autoTrack', commonPropertys)
    this.cbFn()
  }
  cbFn () {
    if (!this.cbs.length) return
    this.cbs.forEach(i => {
      const {event, properties} = i
      this.requestTrack(event, properties)
    })
    this.cbs = []
  }
  track (event, properties = {}) {
    if (!this.userId) return this.cbs.push({event, properties})
    this.requestTrack(event, properties)
  }
  requestTrack (event, properties) {
    if (!saConfig) return
    sensors.track(event, properties)
  }
}

export default {
  install (Vue) {
    Vue.prototype.$sa = new Sa()
  }
}
